/* RESPONSIBLE TEAM: team-tickets-1 */
export default function toBackendPermissionKey(frontEndPermissionKey) {
  return frontEndPermissionKey.replace('can_', '');
}
